module.exports = __webpack_public_path__ + "img/instagram-logo-32.ead537b4.svg";